import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useGetPaymentErrorMessages`

export default defineMessages({
  balanceInsufficientHeader: {
    id: `${scope}.insufficientFundsHeader`,
    defaultMessage: 'Insufficient funds',
  },
  balanceInsufficientMessage: {
    id: `${scope}.balanceInsufficientMessage`,
    defaultMessage:
      'Your financial account did not have enough available funds to process this payment.',
  },
  balanceInsufficientResolutionStep: {
    id: `${scope}.balanceInsufficientResolutionStep`,
    defaultMessage:
      'Ensure that there are sufficient funds in your financial account before processing.',
  },
  accountClosedHeader: {
    id: `${scope}.accountClosedHeader`,
    defaultMessage: 'Vendor account closed',
  },
  accountClosedMessage: {
    id: `${scope}.accountClosedMessage`,
    defaultMessage: 'The destination bank account has been closed.',
  },
  accountFrozenHeader: {
    id: `${scope}.accountFrozenHeader`,
    defaultMessage: 'Account inactive',
  },
  accountFrozenMessage: {
    id: `${scope}.accountFrozenMessage`,
    defaultMessage: 'The destination account is inactive or has been frozen.',
  },
  bankAccountRestrictedHeader: {
    id: `${scope}.bankAccountRestrictedHeader`,
    defaultMessage: 'Bank account restricted',
  },
  bankAccountRestrictedMessage: {
    id: `${scope}.bankAccountRestrictedMessage`,
    defaultMessage:
      'The destination bank account has restrictions on either the type or number of transfers allowed. This normally indicates that the bank account is a savings or other non-checking account.',
  },
  bankAccountRestrictedResolutionStep: {
    id: `${scope}.bankAccountRestrictedResolutionStep`,
    defaultMessage: 'Please contact the payee to resolve this problem.',
  },
  couldNotProcessHeader: {
    id: `${scope}.couldNotProcessHeader`,
    defaultMessage: 'Could not process payment',
  },
  couldNotProcessMessage: {
    id: `${scope}.couldNotProcessMessage`,
    defaultMessage:
      'The destination bank account could not process this payment.',
  },
  invalidAccountNumberHeader: {
    id: `${scope}.invalidAccountNumberHeader`,
    defaultMessage: 'Invalid account number',
  },
  invalidAccountNumberMessage: {
    id: `${scope}.invalidAccountNumberMessage`,
    defaultMessage: 'The destination bank account number is incorrect.',
  },
  incorrectAccountHolderNameHeader: {
    id: `${scope}.incorrectAccountHolderNameHeader`,
    defaultMessage: 'Incorrect account holder name',
  },
  incorrectAccountHolderNameMessage: {
    id: `${scope}.incorrectAccountHolderNameMessage`,
    defaultMessage: 'The destination bank account holder name is incorrect.',
  },
  invalidCurrencyHeader: {
    id: `${scope}.invalidCurrencyHeader`,
    defaultMessage: 'Invalid currency',
  },
  invalidCurrencyMessage: {
    id: `${scope}.invalidCurrencyMessage`,
    defaultMessage:
      'The destination bank account was unable to process this payment because of its currency.',
  },
  incorrectBankingInformationHeader: {
    id: `${scope}.incorrectBankingInformationHeader`,
    defaultMessage: 'Incorrect banking information',
  },
  incorrectBankingInformationMessage: {
    id: `${scope}.incorrectBankingInformationMessage`,
    defaultMessage: 'The destination bank account information is incorrect.',
  },
  genericIncorrectBankingInformationResolutionStep: {
    id: `${scope}.genericIncorrectBankingInformationResolutionStep`,
    defaultMessage:
      'Use a different vendor payment method or contact the payee to resolve this problem.',
  },
  regulatoryReasonMessage: {
    id: `${scope}.regulatoryReasonMessage`,
    defaultMessage: 'The transaction is rejected for regulatory reasons.',
  },
  syntaxErrorMessage: {
    id: `${scope}.syntaxErrorMessage`,
    defaultMessage:
      'The direct debit deposit creation is rejected for general validation errors (e.g. the field contains special characters).',
  },
  directDebitInsufficientFundsMessage: {
    id: `${scope}.directDebitInsufficientFundsMessage`,
    defaultMessage:
      'The available balance in the linked bank account is insufficient.',
  },
  directDebitInsufficientFundsResolutionStep: {
    id: `${scope}.directDebitInsufficientFundsResolutionStep`,
    defaultMessage:
      'Please ensure funds are added to the <a>linked bank account</a> and retry.',
  },
  closedAccountNumberMessage: {
    id: `${scope}.closedAccountNumberMessage`,
    defaultMessage: 'Your linked bank account is closed.',
  },
  closedAccountNumberResolutionStep: {
    id: `${scope}.closedAccountNumberResolutionStep`,
    defaultMessage:
      'Contact the bank to reopen the account, or create a new linked bank account in Procurify.',
  },
  blockedAmountMessage: {
    id: `${scope}.blockedAmountMessage`,
    defaultMessage:
      'The available balance in the linked bank account is insufficient. This may be due to pending transactions. ',
  },
  blockedAccountMessage: {
    id: `${scope}.blockedAccountMessage`,
    defaultMessage:
      'The linked bank account has been blocked for ACH direct debits.',
  },
  blockedAccountResolutionStep: {
    id: `${scope}.blockedAccountResolutionStep`,
    defaultMessage:
      'Contact your bank to remove the block, or create a new linked bank account in Procurify.',
  },
  invalidFileFormatMessage: {
    id: `${scope}.invalidFileFormatMessage`,
    defaultMessage:
      'Your bank is unable to process certain fields in the transaction request.',
  },
  settlementFailedMessage: {
    id: `${scope}.settlementFailedMessage`,
    defaultMessage: 'Settlement of the transaction has failed.',
  },
  limitedParticipationDFIMessage: {
    id: `${scope}.limitedParticipationDFIMessage`,
    defaultMessage:
      'The federal or state supervisor of your bank has limited their participation.',
  },
  inactiveLinkedBankAccountMessage: {
    id: `${scope}.inactiveLinkedBankAccountMessage`,
    defaultMessage: 'The linked bank account is no longer active.',
  },
  inactiveLinkedBankAccountResolutionStep: {
    id: `${scope}.inactiveLinkedBankAccountResolutionStep`,
    defaultMessage:
      'Please ensure the <a>linked bank account</a> is active, or use a different one.',
  },
  genericDirectDebitErrorHeader: {
    id: `${scope}.genericDirectDebitErrorHeader`,
    defaultMessage: 'Direct debit error',
  },
  genericDirectDebitErrorResolutionStep: {
    id: `${scope}.genericDirectDebitErrorResolutionStep`,
    defaultMessage: 'Contact your bank for further information.',
  },
  genericErrorHeader: {
    id: `${scope}.genericErrorHeader`,
    defaultMessage: 'Payment processing error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'An unknown issue occurred with the payment.',
  },
  genericResolutionStep: {
    id: `${scope}.genericResolutionStep`,
    defaultMessage:
      'Contact support via <email>support@procurify.com</email> or in-app chat for more information.',
  },
})
